import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { automaticService } from "services";
import { logout } from "../logout";

export const getAssemblyWorkOrderStatistics = createAsyncThunk(
  "getAssemblyWorkOrderStatistics",
  async ({ workOrderId }, { rejectWithValue }) => {
    try {
      return await automaticService.getAssemblyWorkOrderStatistics(workOrderId);
    } catch (error) {
      if (error.message) {
        if (error?.response?.status === 401) {
          logout();
        }
        //No response to request (No service)
        console.log(error);
        console.log("Internet Disconnected");
      } else {
        console.log(error);
        return rejectWithValue(error);
      }
    }
  }
);

const initialState = {
  loading: false,
  error: null,
  currentAssemblyWorkOrder : null,
  currentAssemblyWorkOrderStatistics : null,
};

const assemblyWorkOrderSlice = createSlice({
  name: "assemblyWorkOrder",
  initialState: initialState,
  reducers: {
    setCurrentAssemblyWorkOrder: (state, action) => {
      state.currentAssemblyWorkOrder = action.payload;
    },
    clearAssemblyWorkOrder: (state, _action) => {
      state.currentAssemblyWorkOrder = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAssemblyWorkOrderStatistics.pending, (state, _action) => {
      state.loading = true;
    });
    builder.addCase(getAssemblyWorkOrderStatistics.fulfilled, (state, action) => {
      state.loading = false;
      state.currentAssemblyWorkOrderStatistics = action.payload;
      state.error = null;
    });
    builder.addCase(getAssemblyWorkOrderStatistics.rejected, (state, action) => {
      state.loading = false;
      state.currentAssemblyWorkOrderStatistics = null;
      state.error = action.payload;
    });
  },
});

export const { clearAssemblyWorkOrder,setCurrentAssemblyWorkOrder } = assemblyWorkOrderSlice.actions;
export default assemblyWorkOrderSlice.reducer;
